import React, { forwardRef } from "react"
import styled from "styled-components"

const SummaryViewSVG = forwardRef((props, ref) => {
  return (
    <SVGWrapper ref={ref} width={props.width || 200} color={props.color} version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 225">
      <title>New Project</title>
      <path id="Layer 1" className="s0" d="m0 0h400v225h-400z"/>
      <path id="Shape 6" className="s1 browser-source" d="m12 21c0-3.3 2.7-6 6-6h297c3.3 0 6 2.7 6 6v187c0 3.3-2.7 6-6 6h-297c-3.3 0-6-2.7-6-6z"/>
      <g id="Folder 5">
        <path id="Shape 7" className="s2" d="m23.4 30.5v-5h287.7v5z"/>
        <path id="Shape 7 copy" className="s2" d="m23.4 40.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 2" className="s2" d="m23.4 50.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 3" className="s2" d="m23.4 60.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 4" className="s2" d="m23.4 70.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 5" className="s2" d="m23.4 80.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 6" className="s2" d="m23.4 90.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 7" className="s2" d="m23.4 100.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 8" className="s2" d="m23.4 110.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 9" className="s2" d="m23.4 120.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 10" className="s2" d="m23.4 130.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 11" className="s2" d="m23.4 140.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 12" className="s2" d="m23.4 150.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 13" className="s2" d="m23.4 160.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 14" className="s2" d="m23.4 170.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 15" className="s2" d="m23.4 180.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 16" className="s2" d="m23.4 190.5v-5h287.7v5z"/>
        <path id="Shape 7 copy 17" className="s2" d="m23.4 200.5v-5h287.7v5z"/>
      </g>
    </SVGWrapper>
  )
})

export default SummaryViewSVG

const SVGWrapper = styled.svg`
  --color: ${props => props.color || '#fff'};
  .s0 { fill: none; stroke: var(--color); stroke-width: 10 }
  .s1 { fill: none; stroke: var(--color); stroke-width: 5 }
  .s2 { fill: var(--color) }

  .browser-source {
    stroke: var(--green-text);
    fill: var(--green-selected);
  }
`
